import { resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-inline mr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.warningTimeExpired,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.warningTimeExpired) = $event)),
      "max-width": "600"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_FocusLock, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, {
                  class: "headline font-weight-bold mb-2",
                  textContent: _toDisplayString(_ctx.$t('inactivity.modal.title'))
                }, null, 8, ["textContent"]),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('inactivity.modal.text')) + " (" + _toDisplayString(_ctx.lifetime) + ")", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}